<template>
    <v-app :style="cssVars" id="inspire">
        <my-leftbar :open="open_leftbar"></my-leftbar>
        <v-content>
            <my-header v-if="header"></my-header>
            <my-topbar></my-topbar>
            <!--<account-progress></account-progress>-->
            <v-container class="pt-0 pb-10" style="align-items: start" v-bind:class="{'px-0 pt-0': $route.meta.fullWidth}">
                <div v-bind:class="{'full-width': $route.meta.fullWidth}" :style="{'padding-bottom': (bottom)? '50px' : null}">
                    <connect-integration-banner v-show="$route.fullPath.indexOf('create') < 0"></connect-integration-banner>
                    <transition name="fade-in" mode="out-in">
                        <router-view :key="key" />
                    </transition>
                </div>
            </v-container>
        </v-content>
        <!--<my-footer></my-footer>-->

        <div class="loading-container" v-if="app.loading">
            <div class="scaling-squares-spinner" >
                <div class="square"></div>
                <div class="square"></div>
                <div class="square"></div>
                <div class="square"></div>
            </div>
        </div>
        <bottom-actions></bottom-actions>
        <!--<contact-component></contact-component>-->
        <errors-component></errors-component>
        <image-editor></image-editor>
        <edit-add-variants></edit-add-variants>
        <payment-request></payment-request>
        <payments-vi></payments-vi>
        <email-verify></email-verify>
        <select-dialog></select-dialog>
        <select-website-dialog></select-website-dialog>
        <uploading-progress></uploading-progress>
        <link-edit-add></link-edit-add>
    </v-app>
</template>

<script>
    import {hasTutorial, setTutorial} from "./utilis/auth";
    import myHeader from './views/layout/header';
    import myLeftBar from './views/layout/left-bar';
    import myTopbar from './views/layout/topbar-component';
    import ErrorsComponent from './components/errors';
    import myFooter from './views/layout/footer';
    import ImageEditor from './components/image-editor';
    import ContactComponent from './views/contacts/contacts';
    import EditAddVariants from './views/variants/edit-add';
    import AccountProgress from './views/layout/account_progress';
    import PaymentRequest from './views/payments_requests/payments_request';
    import PaymentsVi from './views/payments_requests/vi_payments';
    import EmailVerify from './views/account/email_verified_at';
    import SelectDialog from './components/dialog-select';
    import BottomActions from './views/layout/bottom-actions';
    import SelectWebsiteDialog from './views/websites/select-active-website-dialog';
    import UploadingProgress from './components/uploading-progress'
    import LinkEditAdd from './components/edit-add-link';
    import ConnectIntegrationBanner from './views/integrations/connection_banner_partials/holder';
    export default {
        name: 'App',
        components:{
            LinkEditAdd,
            UploadingProgress,
            SelectWebsiteDialog,
            BottomActions,
            EditAddVariants,
            ContactComponent,
            ImageEditor,
            myLeftbar: myLeftBar ,
            myTopbar: myTopbar,
            ErrorsComponent,
            myFooter,
            myHeader,
            AccountProgress,
            PaymentRequest,
            EmailVerify,
            PaymentsVi,
            SelectDialog,
            ConnectIntegrationBanner
        },
        computed: {
            bottom(){
                return this.$store.getters.bottom;
            },
            cssVars() {
                var to_return = {};
                for(var index in this.$vuetify.theme.themes.light){
                    to_return['--'+index+'-color'] = this.$vuetify.theme.themes.light[index];
                }
                return to_return;
            },
            app(){
              return this.$store.getters.app;
            },
            key() {
                return this.$route.fullPath;
            },
            header(){
                return this.$store.getters.header;
            }
        },
        mounted(){
            this.$root.$eventBus.$on('left_bar', () => {
                this.open_leftbar = !this.open_leftbar;
            })
            if(this.mobileCheck()){
                this.$store.commit('navigation/SET_OPENED', false);
            }else{
                this.$store.commit('navigation/SET_OPENED', true);
            }
         /*   if(!hasTutorial()){
                setTimeout(() => {
                    var intro = this.$intro();
                    intro.onexit(() => {
                        if(!this.tutorial_confirm){
                            this.$confirm('Tutorial', 'Zauważyliśmy że opuściłeś nasz samouczek. Pamiętaj zawsze możesz zobaczyć podpowiedzi klikając w przycisk znaku zapytania w górnym menu strony. ', {accept: {text: 'Ok', color:'success'}, cancel: {text: 'Nie', visible: false}}).then(res => {})
                            this.tutorial_confirm = true;
                            setTutorial();
                        }
                    })
                    intro.start();
                },2000)
            }*/
        },
        data(){
            return{
                tutorial_confirm: false,
                open_leftbar: false,
            }
        }
    };
</script>
<style lang="scss">
    @import "scss/custom";
    @media screen and (max-width: 1200px){
        .my-container{
            width: 100%;
            max-width: 100%;
        }
    }
    .v-application{
        .primary-normal{
            background: var(--primary-color) !important;
        }
        .secondary-normal{
            background: var(--secondary-color)!important;
        }
        .primary{
            background: var(--primary-color);
        }
    }
    .primary-normal{
        background: var(--primary-color);
    }
    .secondary-normal{
        background: var(--secondary-color);
    }
    .primary{
        background: var(--primary-color);
    }
</style>
